import { STORE_FAILURE, STORE_SUCCESS, STORE_REQUEST, STORE_SELECT, STORE_OPEN, STORE_STATE_LIST } from "../constants/ActionTypes";

const initialState = {
    loading: false,
    stores: null,
    selectedStore: null,
    storeStates: null,
    error: null,
    isOpen: true
};

export default function storeReducer(state = initialState, action) {
    switch (action.type) {
        case STORE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case STORE_SUCCESS:
            return {
                ...state,
                // always replacing data,
                stores: action.data.store_list,
                loading: false,
               
            };
        case STORE_SELECT:
            return {
                ...state,
                selectedStore: action.selectedStore,
                isOpen: false,
                loading: false,
            };
        case STORE_STATE_LIST:
            return {
                ...state,
                storeStates: action.storeStates.store_town_list,
                loading: false,
            };
        case STORE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
            case STORE_OPEN:
                return {
                    ...state,
                   isOpen: !state.isOpen
                };
        default:
            return state;
    }
}
